import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

// import * as AppPropTypes from '../../lib/PropTypes';

const propTypes = {
    number: PropTypes.number,
    ended: PropTypes.bool,
    locked: PropTypes.bool,
    theme: PropTypes.string,
};

const defaultProps = {
    number: null,
    ended: false,
    locked: true,
    theme: 'nhl',
};

function SportPeriodLabel({ number, ended, locked, theme }) {
    if (theme === 'nhl') {
        if (ended) {
            if (number === 1) {
                return (
                    <FormattedMessage
                        defaultMessage="Your first period answers"
                        description="NHL Answers title"
                    />
                );
            }

            if (number === 2) {
                return (
                    <FormattedMessage
                        defaultMessage="Your second period answers"
                        description="NHL Answers title"
                    />
                );
            }
            if (number === 3) {
                return (
                    <FormattedMessage
                        defaultMessage="Your third period answers"
                        description="NHL Answers title"
                    />
                );
            }
        }

        if (locked) {
            if (number === 1) {
                return (
                    <FormattedMessage
                        defaultMessage="Questions will unlock soon"
                        description="NHL locked label"
                    />
                );
            }
            if (number === 2) {
                return (
                    <FormattedMessage
                        defaultMessage="Questions will unlock before the start of the second period."
                        description="NHL locked label"
                    />
                );
            }
            if (number === 3) {
                return (
                    <FormattedMessage
                        defaultMessage="Questions will unlock before the start of the third period."
                        description="NHL locked label"
                    />
                );
            }
        }
    }
    if (theme === 'nfl') {
        if (ended) {
            if (number === 1) {
                return (
                    <FormattedMessage
                        defaultMessage="Your first quarter answers"
                        description="NFL Answers title"
                    />
                );
            }

            if (number === 2) {
                return (
                    <FormattedMessage
                        defaultMessage="Your second quarter answers"
                        description="NFL Answers title"
                    />
                );
            }
            if (number === 3) {
                return (
                    <FormattedMessage
                        defaultMessage="Your third quarter answers"
                        description="NFL Answers title"
                    />
                );
            }
            if (number === 4) {
                return (
                    <FormattedMessage
                        defaultMessage="Your fourth quarter answers"
                        description="NFL Answers title"
                    />
                );
            }
        }

        if (locked) {
            if (number === 1) {
                return (
                    <FormattedMessage
                        defaultMessage="Questions will unlock soon"
                        description="NFL locked label"
                    />
                );
            }
            if (number === 2) {
                return (
                    <FormattedMessage
                        defaultMessage="Questions will unlock before the start of the second quarter."
                        description="NFL locked label"
                    />
                );
            }
            if (number === 3) {
                return (
                    <FormattedMessage
                        defaultMessage="Questions will unlock before the start of the third quarter."
                        description="NFL locked label"
                    />
                );
            }
            if (number === 4) {
                return (
                    <FormattedMessage
                        defaultMessage="Questions will unlock before the start of the fourth quarter."
                        description="NFL locked label"
                    />
                );
            }
        }
    }
    return null;
}

SportPeriodLabel.propTypes = propTypes;
SportPeriodLabel.defaultProps = defaultProps;

export default SportPeriodLabel;
